import classNames from "classnames";
import { Field } from "react-final-form";

import Radio from "@components/Form/Radio";
import { formatPrice } from "@lib/helpers";
import RcaOffersListInfo from "@containers/RCA/RcaOffers/RcaOffersList/RcaOffersListInfo";

const RcaOffersList = ({ groupedOffers, values }) => (
  <>
    {Object.values(groupedOffers).map((companyOffer, index) => {
      const withDirectSettlement = values.withDirectSettlement === "Yes";

      const { companyName, logoUrl, offers } = companyOffer;

      return (
        <div
          key={companyName}
          className={classNames(
            "flex flex-col sm:flex-row sm:items-center gap-[20px] pb-[20px] border-b border-[#E5E5E5]",
            {
              "border-b-0": index === Object.keys(groupedOffers).length - 1,
            }
          )}
        >
          <div className="flex items-center justify-center min-w-[25%]">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={companyName}
                className="max-w-full max-h-full object-contain w-[125px] h-[50px]"
              />
            ) : (
              <span className="font-bold text-sm">{companyName}</span>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-[10px] flex-grow">
            {offers
              .filter(
                (offer) =>
                  offer.offerDetails.withDirectSettlement ===
                  withDirectSettlement
              )
              .map((offer) => {
                const {
                  offerId,
                  offerDetails: {
                    periodMonths,
                    policyPremiumWithDirectSettlement,
                    policyPremium,
                  },
                } = offer;

                return (
                  <div
                    key={offerId}
                    className="flex flex-col gap-[8px] sm:w-[50%]"
                  >
                    <div className="bg-[#FAFAFA] p-[16px]">
                      <Field
                        name="selectedOffer"
                        component={Radio}
                        type="radio"
                        required
                        value={offerId.toString()}
                        label={
                          <div className="flex gap-[4px] cursor-pointer">
                            <span className="text-[14px] font-normal">
                              {periodMonths}{" "}
                              {periodMonths === 1 ? "luna" : "luni"}
                            </span>

                            {" - "}

                            <span className="text-red-brand font-medium text-[18px]">
                              {formatPrice(
                                withDirectSettlement
                                  ? policyPremiumWithDirectSettlement
                                  : policyPremium
                              )}{" "}
                              lei
                            </span>
                          </div>
                        }
                      />

                      <div className="text-[12px] mt-[12px]">
                        <RcaOffersListInfo
                          offer={offer}
                          withDirectSettlement={withDirectSettlement}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      );
    })}
  </>
);

export default RcaOffersList;
